<template>
  <el-dialog
    title="新增"
    :visible.sync="dialogVisible"
    width="680px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form :model="formInline" ref="form" label-width="140px">
        <el-form-item label="问卷标题" prop="title">
          <el-input
            style="width: 356px;"
            v-model="formInline.title"
            placeholder="请输入问卷标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="问卷类型" prop="linkType">
          <el-select
            style="width: 356px;"
            v-model="formInline.linkType"
            placeholder="请选择问卷类型"
          >
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问卷链接" prop="link">
          <el-input
            style="width: 356px;"
            v-model="formInline.link"
            placeholder="请输入问卷链接"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属部门" prop="deptCode">
          <el-select
            style="width: 356px;"
            v-model="formInline.deptCode"
            placeholder="请选择所属部门"
            filterable
          >
            <el-option
              v-for="(item, index) in deptList"
              :key="index"
              :label="item.deptName"
              :value="item.deptCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="eventEditFun">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { wenjuancrateOrUpdate } from "@/api/base.js";
import {
  getCommcommunityAll,
} from "@/api/point.js";
import {
  authUserDeptList
} from "@/api/task.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    },

    typeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      dataRadio: "1",
      mapVisible: false,
      formInline: {
        title: "",
        link: "",
        linkType: "",
        deptCode: "",
        id: "",
      },
      deptList: [],
    };
  },
  created() {
    this.formInline = JSON.parse(JSON.stringify(this.curItem));
    this.authUserDeptListFun();
  },
  methods: {
    // 获取部门资源树形
    async authUserDeptListFun() {
      let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      if (userInfo.roles.map(item => item.roleCode).includes('GLLD')) {
        let params = {
          notEndStr: '网格',
          noAuthFlag: true
        };
        const res = await authUserDeptList(params);
        this.deptList = res.data.data;
      } else {
        let res = await getCommcommunityAll();
        if (res.data.code == 200) {
          let actionsData = res.data.data.map((item) => ({
            deptName: item.pointName,
            deptCode: item.deptCode,
          }));
          let depcode = JSON.parse(
            sessionStorage.getItem("userInfo")
          ).detpCode;
          // let depcode = "4403260050232323";
          if (depcode.length < 12) {
            // this.deptList = JSON.parse(JSON.stringify(actionsData));
            this.deptList = [];
            this.formInline.deptCode = userInfo.deptId;
            this.deptList.push({
              deptCode: userInfo.deptId,
              deptName: userInfo.deptName
            })
          } else {
            let code = depcode.slice(0, 12);
            this.deptList = actionsData.filter(
              (item) => item.deptCode == code
            );
            if (this.deptList.length) {
              this.formInline.deptCode = this.deptList[0].deptCode;
            } else {
              this.deptList = [];
              this.formInline.deptCode = userInfo.deptId;
              this.deptList.push({
                deptCode: userInfo.deptId,
                deptName: userInfo.deptName
              })
            }
          }
        }
      }
    },
    handleClose() {
      this.$emit("update:dialogVisible", false);
    },
    async eventEditFun() {
      if (!this.formInline.title) return this.$message.error('请输入问卷标题');
      if (!this.formInline.linkType) return this.$message.error('请选择问卷类型');
      if (!this.formInline.link) return this.$message.error('请输入问卷链接');
      if (!this.formInline.deptCode) return this.$message.error('请选择所属部门');
      let params = {
        ...this.formInline,
        deptName: this.deptList.find(item => item.deptCode == this.formInline.deptCode).deptName || '' ,
        state: "未发布",
      };
      const res = await wenjuancrateOrUpdate(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-input {
  width: 340px !important;
}
/deep/.el-upload__input {
  display: none;
}
/deep/.avatar-uploader {
  display: flex;
}
.el-upload__text {
  height: auto;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #494c4f;
  display: inline-block;
  margin: 8px 0;
}
.tip {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #92979c;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/jmhd/components/issuesDialog.vue